import React from 'react';
import { Skeleton } from 'antd';
import { I18n } from '@aws-amplify/core';
import { CustomSelectProps } from './types';
import * as S from './styles';

export function Default({
	placeholder = '',
	disabled = false,
	loading = false,
	...props
}: Readonly<CustomSelectProps>): JSX.Element {
	return (
		<>
			{loading ? (
				<Skeleton.Button active />
			) : (
				<S.SelectWrapper {...props} placeholder={I18n.get(placeholder)} disabled={disabled} />
			)}
		</>
	);
}
